import type { PlannerPreferences } from "./preferences";

export const STOP_PLACEMENT_WINDOW_H = 0.5;

export const LUNCH_DURATION_MIN: Record<
  Exclude<PlannerPreferences["lunch"]["style"], "skip">,
  number
> = {
  packed: 25,
  cheap: 50,
  "sit-down": 80,
};

export const COFFEE_DURATION_MIN = 25;
export const APRES_DURATION_MIN = 60;
export const COFFEE_AM_DEFAULT_HOUR = 10.5;
export const COFFEE_PM_DEFAULT_HOUR = 15;
export const APRES_TARGET_BEFORE_END_H = APRES_DURATION_MIN / 60;
